import React from "react";

// --- NEW COMPONENT: Floating Logo Wall (Contained & Transparent) ---
const IntegrationsBanner = () => {
  // Styles for the marquee animation
  const marqueeStyle = {
    display: "flex",
    width: "max-content",
    animation: "marquee 60s linear infinite",
  };

  const marqueeReverseStyle = {
    display: "flex",
    width: "max-content",
    animation: "marqueeReverse 60s linear infinite",
  };

  return (
    // UPDATED: Added full width gray background and changed margins to padding
    <div className="w-full py-20 border-t  border-gray-500">
      <div className="w-full max-w-7xl mx-auto px-4">
        <div className="relative w-full overflow-hidden bg-transparent group">
          <style>{`
            @keyframes marquee {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            @keyframes marqueeReverse {
              0% { transform: translateX(-50%); }
              100% { transform: translateX(0); }
            }
            .mask-gradient {
              mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
              -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
            }
          `}</style>

          <div className="relative z-20 text-center max-w-3xl mx-auto px-4 mb-12">
            {/* UPDATED: Removed 'tracking-tight', added 'not-italic', changed to 'font-semibold' for a simpler look */}
            <h2 className="text-3xl md:text-3xl font-semibold text-gray-900 mb-6 not-italic">
              Secure Your Data+Users Everywhere
            </h2>
            <p className="text-gray-600 text-sm md:text-sm non-italic">
              With 1000s of pre-built integrations across hybrid multicloud and
              SaaS
            </p>
          </div>

          <div className="flex flex-col gap-6 mask-gradient">
            {/* ROW 1 */}
            <div className="w-full overflow-hidden">
              <div style={marqueeStyle}>
                {[...Array(4)].map((_, i) => (
                  <img
                    key={i}
                    src="https://res.cloudinary.com/dpn3bkjba/image/upload/v1764852824/sass-group-one_ztrkcs.svg"
                    alt="SaaS Integrations Group 1"
                    // UPDATED: Reduced height to h-12 md:h-16 and margin to mx-4
                    className="h-12 md:h-16 mx-4 flex-shrink-0 max-w-none opacity-90 hover:opacity-100 transition-opacity"
                  />
                ))}
              </div>
            </div>
            {/* ROW 2 */}
            <div className="w-full overflow-hidden">
              <div style={marqueeReverseStyle}>
                {[...Array(4)].map((_, i) => (
                  <img
                    key={i}
                    src="https://res.cloudinary.com/dpn3bkjba/image/upload/v1764852824/sass-group-two_p6xxs7.svg"
                    alt="SaaS Integrations Group 2"
                    // UPDATED: Reduced height to h-12 md:h-16 and margin to mx-4
                    className="h-12 md:h-16 mx-4 flex-shrink-0 max-w-none opacity-90 hover:opacity-100 transition-opacity"
                  />
                ))}
              </div>
            </div>
            {/* ROW 3 */}
            <div className="w-full overflow-hidden">
              <div style={marqueeStyle}>
                {[...Array(4)].map((_, i) => (
                  <img
                    key={i}
                    src="https://res.cloudinary.com/dpn3bkjba/image/upload/v1764852825/llm-group-one_atusht.svg"
                    alt="LLM Integrations"
                    // UPDATED: Reduced height to h-12 md:h-16 and margin to mx-4
                    className="h-12 md:h-16 mx-4 flex-shrink-0 max-w-none opacity-90 hover:opacity-100 transition-opacity"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- ICONS (Emerald Green Theme) ---
const SearchIcon = (
  <div className="w-16 h-16 bg-green-900  rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  </div>
);
const ComplianceIcon = (
  <div className="w-16 h-16 bg-green-900  rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <path d="M16 13H8"></path>
      <path d="M16 17H8"></path>
      <path d="M10 9H8"></path>
    </svg>
  </div>
);
const ShieldIcon = (
  <div className="w-16 h-16 bg-green-900  rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  </div>
);
const LockIcon = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
    </svg>
  </div>
);
const RobotIcon = (
  <div className="w-16 h-16 bg-green-900  rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="11" width="18" height="10" rx="2"></rect>
      <circle cx="12" cy="5" r="2"></circle>
      <path d="M12 7v4"></path>
      <line x1="8" y1="16" x2="8" y2="16"></line>
      <line x1="16" y1="16" x2="16" y2="16"></line>
    </svg>
  </div>
);

// --- DATA ---

export const aiFeatures = [
  {
    id: "discovery-risk-assessment",
    title: "Discovery & Risk Assessment",
    icon: SearchIcon,
    heading: "Discover every AI asset. Know your risk. Secure your AI future.",
    points: [
      "Complete visibility into AI models, agents, and the sensitive data powering them",
      "Real-time risk scoring prioritizes what to protect first",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1762263228/Discovery_Risk_Assessment_wvj3yp.png",

    detailHeading: "Discovery & Risk Assessment",
    detailSubheadline:
      "See every AI model, agent, and the sensitive data powering them. Quantify risk. Take action.",
    detailIntro: [
      "Most enterprises don't know what AI they're running or what data feeds it.",
      "Shadow AI + hidden data = compliance exposure, security risk, unknown liability.",
    ],
    detailBullets: [
      "Visualization of AI models connected to data sources",
      "Risk scoring dashboard visual",
      "Real-time monitoring dashboard",
      "Color scheme: Brand green, grays, data visualization colors",
    ],
    detailConclusion: <IntegrationsBanner />,

    cards: [
      {
        emoji: "🔍",
        title: "Complete Inventory",
        description:
          "AI models + data sources discovered automatically across all environments in days, not months",
        stat: "Discover blind spots in 48 hours",
      },
      {
        emoji: "👻",
        title: "Shadow AI + Data Detection",
        description:
          "Unauthorized AI deployments + unmanaged data stores exposed and cataloged automatically",
        stat: "80% of enterprises run shadow AI",
      },
      {
        emoji: "⚖️",
        title: "Risk Quantified",
        description:
          "Models scored on data privacy + compliance + adversarial risk with business context for prioritization",
        stat: "Reduce risk exposure by 75%",
      },
      {
        emoji: "📈",
        title: "Continuous Posture",
        description:
          "Real-time monitoring of models, data, access patterns with security correlation and alerting",
        stat: "Catch 95% of anomalies pre-production",
      },
    ],
    // Key Capabilities with Bullet Points
    // extraSections: [
    //   {
    //     title: "AI Asset Discovery",
    //     // Changing description to ARRAY for bullets
    //     description: [
    //       "Auto-discover AI models, LLMs, agents across cloud/on-prem/SaaS environments.",
    //       "Detect shadow AI deployments and unauthorized usage.",
    //       "Classify models by maturity, risk tier, business function, and data sensitivity.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764690498/app_discovery_hgx5la.png",
    //   },
    //   {
    //     title: "Data Security Posture Management",
    //     description: [
    //       "Discover ALL sensitive data: PII, PHI, PCI, financial records, and intellectual property.",
    //       "Map data lineage from origin → ETL pipelines → AI training → inference outputs.",
    //       "Identify 'toxic combinations' of sensitive data and overprivileged access.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Dynamic Risk Scoring",
    //     description: [
    //       "Score AI models on data privacy exposure, bias potential, adversarial vulnerabilities, and compliance gaps.",
    //       "Correlate model risk with regulatory requirements (GDPR, HIPAA, EU AI Act) and prioritize by business impact.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764690498/Intelligent_Access_with_Modern_CASB_yuaaoe.png",
    //   },
    //   {
    //     title: "Continuous Monitoring & Threat Simulation",
    //     description: [
    //       "Monitor model behavior, data drift, and access pattern changes 24/7 with ML-powered anomaly detection.",
    //       "Run automated red-team exercises like prompt injection tests and adversarial probing to catch issues pre-production.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764690498/Data_Loss_Prevention_Threat_Defense_cp1mp3.png",
    //   },
    // ],
    // New "Why This Matters" Section
    whyThisMatters: {
      title: "WHY THIS MATTERS (Emotional + Business Impact)",
      text: "Complete visibility into your AI landscape models, data, risks, and compliance exposure. The foundation for everything else. You can't govern what you can't see. You can't protect what you don't understand. Synthera shows you everything.",
    },
  },

  {
    id: "compliance-policy-control",
    title: "Compliance & Policy Control",
    icon: ComplianceIcon,
    heading: "Automate compliance. Enforce policies. Stay audit-ready.",
    points: [
      "Automate 25+ regulatory frameworks (EU AI Act, NIST, GDPR, HIPAA)",
      "Audit-ready evidence in minutes, not weeks",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1762263225/Compliance_Policy_Control_dxzkvf.jpg",

    detailHeading: "Compliance & Policy Control",
    detailSubheadline:
      "Automate compliance. Enforce policies. Stay audit ready.",
    detailIntro: [
      "Compliance with evolving AI regulations is impossible to manage manually.",
      "Outdated spreadsheets + ad-hoc audits + regional complexity = massive risk, fines, and stalled innovation.",
    ],
    detailBullets: [
      "Compliance framework icons (EU AI Act, NIST, GDPR, HIPAA, etc.",
      "Automated policy enforcement visual",
      "Audit trail documentation",
      "Color: Green + regulatory blue tones",
    ],
    detailConclusion: <IntegrationsBanner />,

    // extraSections: [
    //   {
    //     title: "Regulatory Framework Automation",
    //     description: [
    //       "Pre-built policies for 25+ frameworks: EU AI Act, NIST AI RMF, ISO 42001, GDPR, HIPAA, CCPA, SOX, LGPD, plus sector-specific rules.",
    //       "Auto-map regulations to your AI models, data, and controls—understand compliance requirements instantly.",
    //       "Instant compliance readiness for new markets and jurisdictions—launch globally without manual work.",
    //       "Frameworks update automatically as regulations change—stay compliant without manual tracking.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298808/application_arhoec.png",
    //   },
    //   {
    //     title: "Continuous Compliance Testing",
    //     description: [
    //       "500+ automated compliance controls running 24/7 across all AI assets.",
    //       "Real-time testing for data privacy, model transparency, audit readiness, governance effectiveness.",
    //       "Gap detection and auto-remediation workflows—fix issues before audits find them.",
    //       "Compliance status dashboard with real-time visibility—always know your compliance score.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298808/application_arhoec.png",
    //   },
    //   {
    //     title: "Policy Enforcement That Works",
    //     description: [
    //       "Regulations → live operational policies automatically enforced (not static PDFs that nobody reads).",
    //       "Applied automatically at model deployment, training, and inference stages.",
    //       "Human-in-the-loop for high-risk decisions—governance with judgment, not just automation.",
    //       "Policy versioning and change audit trails—every decision logged and justified.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298808/application_arhoec.png",
    //   },
    //   {
    //     title: "Audit-Ready Evidence",
    //     description: [
    //       "Every policy check, test, approval, remediation logged with cryptographic proof.",
    //       "One-click compliance reports for regulators, boards, auditors—no cherry-picking, just truth.",
    //       "Reduce audit prep from 6 weeks to hours—all evidence automatically compiled and organized.",
    //       "Compliance evidence timestamped and tamper-proof—passes any regulatory audit.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298808/application_arhoec.png",
    //   },
    // ],
    cards: [
      {
        emoji: "📋",
        title: "25+ Pre-Built Frameworks",
        description:
          "EU AI Act, NIST, ISO, GDPR, HIPAA auto-configured and maintained day 1 compliance",
        stat: "Day 1 compliance. Always audit ready.",
      },
      {
        emoji: "✓",
        title: "Continuous Testing",
        description:
          "500+ compliance controls run automatically, gaps surface instantly no surprises",
        stat: "Audit prep: weeks → minutes",
      },
      {
        emoji: "🔒",
        title: "Policies Enforce Themselves",
        description:
          "Regulations become live controls monitored and enforced in real-time across all operations",
        stat: "Automated workflows.",
      },
      {
        emoji: "📊",
        title: "Tamper-Proof Evidence",
        description:
          "Every decision logged with cryptographic proof regulators trust the evidence",
        stat: "Reports regulators trust.",
      },
    ],
    whyThisMatters: {
      title: "WHY THIS MATTERS (Regulatory + Business)",
      text: "Compliance is no longer a checkbox or a scramble. It's automated, continuous, and enforced. You're not compliant just for audits you're building compliance into how your AI actually works. That's how you scale AI confidently.",
    },
  },

  {
    id: "runtime-infrastructure security",
    title: "AI Runtime & Infrastructure Security",
    icon: ShieldIcon,
    heading: "Protect AI models and pipelines with real-time defenses.",
    points: [
      "Stop prompt injection attacks, model poisoning, and adversarial inputs in real-time",
      "Secure CI/CD pipelines from development through production",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1762263436/AI_Runtime_Infrastructure_Security_kpjvvf.png",

    detailHeading: "AI Runtime & Infrastructure Security",
    detailSubheadline:
      "Protect AI models and pipelines with real time defenses and secure operations.",
    detailIntro: [
      "AI models face attacks traditional security can't defend against.",
      "Prompt injections, model poisoning, adversarial inputs, model theft, pipeline tampering—you need AI-aware defenses built into your infrastructure.",
    ],
    detailBullets: [
      "Shield protecting AI models visual",
      "Real-time threat detection dashboard",
      "Secure pipeline architecture diagram",
      "Color: Green + security red for alerts",
    ],
    detailConclusion: <IntegrationsBanner />,

    // extraSections: [
    //   {
    //     title: "Runtime Model Protection",
    //     description: [
    //       "Real-time detection and blocking of prompt injections, jailbreaks, adversarial inputs, token manipulation.",
    //       "Model behavior analysis: detect unusual outputs, hallucinations, drift, out-of-distribution predictions.",
    //       "Automated response: flag suspicious requests, sanitize malicious inputs, or reject outright—zero approval needed.",
    //       "Layer 7 application-level defense built for AI models—understands model semantics, not just network traffic.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/EndpointIoT_Securit_idwovc.png",
    //   },
    //   {
    //     title: "Secure AI Pipelines",
    //     description: [
    //       "CI/CD pipeline hardening: prevent model tampering, data poisoning, unauthorized changes throughout development.",
    //       "Supply chain validation: vet and sandbox third-party models before integration into production systems.",
    //       "Model artifact signing and integrity verification—cryptographic proof of model authenticity.",
    //       "Immutable audit logs for all model changes—every deployment decision recorded and justified.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/EndpointIoT_Securit_idwovc.png",
    //   },
    //   {
    //     title: "Data Protection in AI Workloads",
    //     description: [
    //       "Encryption of training and inference data: at rest, in transit, and during computation—no exposure.",
    //       "Confidential computing: hardware-backed encryption ensures data stays encrypted even during AI computation.",
    //       "Automated data redaction in logs and outputs—sensitive data never leaks to monitoring systems.",
    //       "Privacy-preserving inference without exposing sensitive data—compute on encrypted data directly.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/EndpointIoT_Securit_idwovc.png",
    //   },
    //   {
    //     title: "Behavioral Anomaly Detection",
    //     description: [
    //       "Detect model drift, performance degradation, unusual access patterns—spot problems before they compound.",
    //       "Monitor data lineage: track sensitive data flows through pipelines, catch unauthorized data usage.",
    //       "Alert on unauthorized data exfiltration or model exporting—prevent IP theft in real-time.",
    //       "Correlation with infrastructure and network signals—holistic view of AI attack surface.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/EndpointIoT_Securit_idwovc.png",
    //   },
    // ],
    cards: [
      {
        emoji: "🛡️",
        title: "Runtime Defense",
        description:
          "Prompt injection + adversarial attacks blocked in real-time zero successful attacks",
        stat: "Block 100% of injection attempts",
      },
      {
        emoji: "🔄",
        title: "Secure Pipelines",
        description:
          "CI/CD hardened against tampering, poisoning, unauthorized changes supply chain secured",
        stat: "90% reduction in vulnerabilities",
      },
      {
        emoji: "🔐",
        title: "Encrypted Always",
        description:
          "Data encrypted at rest, in transit, during computation zero data leaks possible",
        stat: "Zero data leaks",
      },
      {
        emoji: "👁️",
        title: "Drift Detection",
        description:
          "Model drift, behavioral anomalies, data exfiltration detected automatically early warning",
        stat: "70% faster incident response",
      },
    ],
    whyThisMatters: {
      title: "WHY THIS MATTERS (Enterprise Confidence)",
      text: "Your AI is protected from the code commit through every production inference call. You can deploy with confidence. Your models are secure. Your data is protected. Your pipelines are defended.",
    },
  },

  {
    id: "data-privacy-protection",
    title: "Data Privacy & Protection",
    icon: LockIcon,
    heading: "Encrypt, mask, and protect sensitive data in AI systems.",
    points: [
      "Discover and encrypt sensitive data flowing through AI training and inference",
      "GDPR/HIPAA compliance built-in, zero performance impact",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1762263654/Data_Privacy_Protection_resrah.png",

    detailHeading: "Data Privacy & Protection",
    detailSubheadline:
      "Encrypt, mask, and protect sensitive data flowing through AI systems.",
    detailIntro: [
      "AI training and inference use sensitive data—patient records, financial data, customer PII.",
      "Without privacy controls, data breaches and regulatory violations are inevitable. Sensitive data is your biggest AI liability.",
    ],
    detailBullets: [
      "Data encryption visual (locks, keys, data flow)",
      "Masked PII data representation",
      "Privacy compliance badges (GDPR, HIPAA)",
      "Color: Green + privacy blue",
    ],
    detailConclusion: <IntegrationsBanner />,

    // extraSections: [
    //   {
    //     title: "Data Discovery & Classification",
    //     description: [
    //       "Automated discovery of sensitive data (PII, PHI, PCI, financial records, trade secrets, intellectual property).",
    //       "Smart classification with business context tags: owner, purpose, sensitivity level, retention requirement.",
    //       "Shadow data detection: find forgotten or mismanaged sensitive data stores before they cause breaches.",
    //       "Continuous classification as new data arrives—governance that scales with your data.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Data Encryption & Masking",
    //     description: [
    //       "Transparent encryption: data encrypted without performance impact—users don't notice.",
    //       "Masking & tokenization: protect sensitive fields while preserving data patterns for AI model training.",
    //       "Format-preserving encryption: encrypt data but maintain usability for algorithms.",
    //       "Key management and rotation automated—no manual key handling, zero human error.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Privacy-by-Design Workflows",
    //     description: [
    //       "Enforce data minimization: only necessary data reaches AI pipelines—less data = less risk.",
    //       "Automated data retention and deletion policies—data deleted on schedule, compliance automatic.",
    //       "GDPR/HIPAA/CCPA compliance built into every workflow—not bolted on, baked in.",
    //       "Consent management and tracking—prove you have permission for every data use.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Confidential Computing",
    //     description: [
    //       "Hardware-backed encryption: data stays encrypted even during AI computation—maximum assurance.",
    //       "Zero-knowledge processing: sensitive data never exposed in plain text to any system.",
    //       "Trusted execution environments for sensitive model training—isolated, tamper-proof processing.",
    //       "Enclave-based inference for maximum privacy—compute on encrypted data directly.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    // ],
    cards: [
      {
        emoji: "🔐",
        title: "Encryption Always On",
        description:
          "Data encrypted at rest, in transit, during computation no exposure windows",
        stat: "Zero overhead",
      },
      {
        emoji: "🎭",
        title: "Smart Masking",
        description:
          "Sensitive fields masked, data patterns preserved for AI training train on real patterns safely",
        stat: "Train AI on protected data",
      },
      {
        emoji: "🛡️",
        title: "Data Minimization",
        description:
          "Only necessary data enters AI pipelines, auto-deleted on schedule minimize exposure",
        stat: "GDPR-compliant default",
      },
      {
        emoji: "🔒",
        title: "Confidential Compute",
        description:
          "Hardware-backed encryption during AI processing the highest level of data protection",
        stat: "Zero-knowledge processing",
      },
    ],
    whyThisMatters: {
      title: "WHY THIS MATTERS (Trust + Innovation)",
      text: "Sensitive data is no longer a blocker to AI innovation. Privacy controls enable safe, compliant AI at scale. You can innovate confidently. Your customers trust you. Your regulators trust you. Your board sleeps well.",
    },
  },

  {
    id: "agentic-ai-governance",
    title: "Agentic AI Security",
    icon: RobotIcon,
    heading: "Secure autonomous AI agents and multi-agent workflows.",
    points: [
      "Discover all autonomous agents, including shadow agents",
      "Fine-grained access control + behavioral monitoring 24/7",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1762263654/Agentic_AI_Security_Multi-Agent_Governance._nzblmn.png",

    detailHeading: "Agentic AI Security & Multi-Agent Governance",
    detailSubheadline: "Secure autonomous AI agents and multi-agent workflows.",
    detailIntro: [
      "Autonomous AI agents make decisions and take actions independently.",
      "Without governance, one rogue agent causes cascading failures or security breaches. Enterprise adoption of agentic AI demands specialized control built from the ground up.",
    ],
    detailBullets: [
      "Multi-agent network diagram",
      "Autonomous agent decision trees",
      "Control and monitoring dashboard",
      "Color: Green + future-tech purple/blue",
    ],
    detailConclusion: <IntegrationsBanner />,

    // extraSections: [
    //   {
    //     title: "Agent Discovery & Classification",
    //     description: [
    //       "Continuous discovery of autonomous agents across all environments—cloud, on-prem, edge, embedded.",
    //       "Detect shadow agents: unauthorized agentic AI running outside official governance causing blind spots.",
    //       "Classify agents by autonomy level, business function, risk tier, data access, decision scope.",
    //       "Track agent creation, ownership, deployment source, and approval status—governance audit trail.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764585984/appication_secu_svrprp.webp",
    //   },
    //   {
    //     title: "Agent Identity & Access Management",
    //     description: [
    //       "Fine-grained IAM for AI agents: least-privilege access control adapted for autonomous systems.",
    //       "Prevent privilege escalation: agents can't elevate permissions even if compromised.",
    //       "Just-in-time access for sensitive operations, human approval required for high-risk actions.",
    //       "Role-based access control adapted for autonomous systems—agents are users too.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764585984/appication_secu_svrprp.webp",
    //   },
    //   {
    //     title: "Behavioral Monitoring & Trust Enforcement",
    //     description: [
    //       "Monitor agent workflows, actions, and inter-agent communications 24/7 with behavioral AI.",
    //       "Detect malicious behavior: unauthorized access, data exfiltration, policy violations, unusual patterns.",
    //       "Track agent decision rationale and action trails for audit/compliance—prove what agents decided and why.",
    //       "Rate limit and throttle agents to prevent runaway execution—kill switches built-in.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764585984/appication_secu_svrprp.webp",
    //   },
    //   {
    //     title: "Incident Response & Compliance",
    //     description: [
    //       "Automated incident detection and response for agentic threats—respond faster than humans.",
    //       "Rapid agent isolation, policy enforcement, human escalation—stop problems immediately.",
    //       "Compliance-ready audit logs for all agent actions and decisions—every decision recorded with context.",
    //       "Automated rollback of unauthorized changes—undo agent actions if needed.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764585984/appication_secu_svrprp.webp",
    //   },
    // ],
    cards: [
      {
        emoji: "🤖",
        title: "Agent Discovery",
        description:
          "All autonomous agents discovered automatically, including shadow agents—total visibility",
        stat: "Discovered 47 shadow agents",
      },
      {
        emoji: "🔑",
        title: "Least Privilege",
        description:
          "Fine-grained access controls prevent privilege escalation in AI systems",
        stat: "Prevented 30+ escalations",
      },
      {
        emoji: "🕵️",
        title: "Behavioral Monitoring",
        description:
          "Agent workflows, communications, actions monitored for anomalies constant vigilance 24/7",
        stat: "100% anomaly detection",
      },
      {
        emoji: "🚨",
        title: "Rapid Response",
        description:
          "Incidents detected + isolated + resolved automatically—response time in seconds, not hours",
        stat: "Response time: minutes",
      },
    ],
    whyThisMatters: {
      title: "WHY THIS MATTERS (AI Future + Control)",
      text: "Autonomous agents power innovation. Governance keeps them safe, compliant, and trustworthy. You can deploy agentic AI with confidence. Your agents are controlled. Your data is protected. Your business is safe.",
    },
  },
];
